import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { requiredValidation } from "admin/const/validation";
import React from "react";
import {
  BooleanInput,
  CreateBase,
  EditBase,
  SaveButton,
  SimpleForm,
  TextInput,
  useNotify,
  useRecordContext,
} from "react-admin";

const FormSubtitle = ({ children }) => {
  return (
    <Box mb={1}>
      <Typography component={"p"} variant={"overline"}>
        {children}
      </Typography>
    </Box>
  );
};

const FormContainer = ({ handleClose }) => {
  const record = useRecordContext();

  return (
    <>
      <DialogTitle>
        {record}
        {record
          ? `Edition d'un type d'intervention`
          : `Création d'un nouveau type d'intervention`}
      </DialogTitle>
      <DialogContent>
        <FormSubtitle>Informations générales</FormSubtitle>
        <Box mb={1}>
          <TextInput
            validate={requiredValidation}
            placeholder={"OMNIS"}
            name={"code"}
            fullWidth
            source={"code"}
            label={"Code"}
          />
        </Box>
        <Box mb={1}>
          <TextInput
            validate={requiredValidation}
            placeholder={"Sit corrupti non omnis et."}
            name={"label"}
            fullWidth
            source={"label"}
            label={"Intitulé"}
          />
        </Box>
        <Box mb={1}>
          <BooleanInput
            source={"active"}
            label="Inactif / Actif"
            defaultValue
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"space-between"}>
          <Grid item>
            <Button color={"error"} onClick={handleClose}>
              Annuler
            </Button>
          </Grid>
          <Grid item>
            <SaveButton
              variant={"text"}
              form={"create_intervention_type_form"}
              label={record ? "Sauvegarder les modifications" : "Créer"}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};

export const InterventionTypeForm = ({ id, handleClose, open, record }) => {
  return (
    <SimpleForm
      toolbar={false}
      component={"div"}
      mode={"onBlur"}
      reValidateMode={"onChange"}
      id={id}
    >
      <Dialog open={open} onClose={handleClose}>
        <FormContainer handleClose={handleClose} />
      </Dialog>
    </SimpleForm>
  );
};

const DialogAddInterventionType = ({ open, handleClose }) => {
  const notify = useNotify();

  const onSuccess = () => {
    notify("Nouveau Type enregistré");
    handleClose();
  };

  return (
    <CreateBase
      resource={"intervention_types"}
      component={React.Fragment}
      mutationOptions={{ onSuccess }}
    >
      <InterventionTypeForm
        id={"create_intervention_type_form"}
        handleClose={handleClose}
        open={open}
      />
    </CreateBase>
  );
};

export const DialogEditInterventionType = ({ open, handleClose, id }) => {
  const notify = useNotify();

  const onSuccess = () => {
    notify("Modifications enregistrées");
    handleClose();
  };

  return (
    <EditBase
      resource={"intervention_types"}
      component={React.Fragment}
      mutationOptions={{ onSuccess }}
    >
      <InterventionTypeForm
        id={"create_intervention_type_form"}
        handleClose={handleClose}
        open={open}
      />
    </EditBase>
  );
};

export default DialogAddInterventionType;
